import React, { useState, useEffect } from 'react';

const InactiveAccountPopover = ({
    extensionName = "",
    icon = null,
    intervalTime = 3600000, // default to 1 hour
    showImmediately = true,
    storageKey = null
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [refreshHandler, setRefreshHandler] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const isPopoverShow = () => {
        if (!storageKey) return false;
        const value = localStorage.getItem(storageKey);
        return value === 'true' || value === true;
    };

    useEffect(() => {
        const handleCustomStorageChange = (e) => {
            if (e.detail && e.detail.key === storageKey) {
                setRefreshHandler(prev => !prev);
            }
        };

        window.addEventListener('localStorageChange', handleCustomStorageChange);

        return () => {
            window.removeEventListener('localStorageChange', handleCustomStorageChange);
        };
    }, [storageKey]);

    useEffect(() => {
        const storageConditionMet = isPopoverShow();

        if (!storageConditionMet) {
            setIsVisible(false);
            return;
        }

        // Get last shown time from localStorage
        const lastShownFromStorage = localStorage.getItem(`${storageKey}_lastShown`);
        const lastShownTime = lastShownFromStorage ? parseInt(lastShownFromStorage) : null;
        const now = Date.now();
        const timePassed = !lastShownTime || (now - lastShownTime) >= intervalTime;

        console.log("timePassed", timePassed, (now - lastShownTime), intervalTime);
        if (showImmediately && timePassed) {
            setIsVisible(true);
            const currentTime = Date.now();
            localStorage.setItem(`${storageKey}_lastShown`, currentTime.toString());
        }

        const intervalId = setInterval(() => {
            console.log("interval called", new Date().toISOString());
            const currentTime = Date.now();
            const storedLastShown = localStorage.getItem(`${storageKey}_lastShown`);
            const lastTime = storedLastShown ? parseInt(storedLastShown) : null;
            const intervalPassed = !lastTime || (currentTime - lastTime) >= intervalTime;

            if (intervalPassed && isPopoverShow()) {
                setIsVisible(true);
                localStorage.setItem(`${storageKey}_lastShown`, currentTime.toString());
            }
        }, intervalTime);

        return () => clearInterval(intervalId);
    }, [intervalTime, showImmediately, storageKey, refreshHandler]);

    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
            }}
        >
            <div
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    padding: '36px',
                    maxWidth: '500px',
                    width: '90%',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    position: 'relative',
                    textAlign: 'center',
                    border: '2px solid #fbbf24'
                }}
            >
                <button
                    onClick={() => setIsVisible(false)}
                    style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: 'transparent',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#6b7280',
                        padding: '4px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '32px',
                        height: '32px'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                    onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                    ×
                </button>

                <div
                    style={{
                        width: '72px',
                        height: '72px',
                        backgroundColor: icon ? '#fef7ed' : '#fef3c7',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '24px auto 28px auto',
                        border: icon ? '3px solid #f59e0b' : '3px solid #f59e0b',
                        overflow: 'hidden',
                        boxShadow: '0 8px 25px rgba(245, 158, 11, 0.3)'
                    }}
                >
                    {!icon ? (
                        <span style={{ fontSize: '32px', color: '#d97706' }}>⚠️</span>
                    ) : typeof icon === 'string' ? (
                        <>
                            <img
                                src={icon}
                                alt={`${extensionName} icon`}
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    objectFit: 'contain',
                                    borderRadius: '50%'
                                }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                }}
                            />
                            <span style={{ fontSize: '32px', color: '#d97706', display: 'none' }}>⚠️</span>
                        </>
                    ) : (
                        <div style={{ fontSize: '32px' }}>{icon}</div>
                    )}
                </div>

                <div
                    style={{
                        padding: '0 8px',
                        marginBottom: '6px'
                    }}
                >
                    <span
                        style={{
                            display: 'inline-block',
                            backgroundColor: '#fef3c7',
                            color: '#d97706',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            border: '1px solid #f59e0b'
                        }}
                    >
                        Action Required
                    </span>
                </div>

                <h2
                    style={{
                        fontSize: '26px',
                        fontWeight: '700',
                        color: '#111827',
                        marginBottom: '16px',
                        lineHeight: '1.2'
                    }}
                >
                    Your Account Needs Action
                </h2>

                {/* <p
                    style={{
                        fontSize: '16px',
                        color: '#4b5563',
                        lineHeight: '1.6',
                        marginBottom: '32px',
                        fontWeight: '500'
                    }}
                >
                   <a href='https://www.geniuscrm.io/' target='_blank'>Click here</a> to regain access to the software or contact <strong style={{ color: '#2563eb' }}>sales@tier5.us</strong> immediately.
                </p> */}
                <p
                    style={{
                        fontSize: '16px',
                        color: '#4b5563',
                        lineHeight: '1.6',
                        marginBottom: '32px',
                        fontWeight: '500'
                    }}
                    >
                    <a
                        href="https://www.geniuscrm.io/lc"
                        target="_blank"
                        style={{ color: isHovered ?'#008000':'#2563eb', textDecoration: 'none' }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        Click here
                    </a>{' '}
                    to regain access to the software or contact{' '}
                    <strong style={{ color: '#2563eb' }}>sales@tier5.us</strong> immediately.
                    </p>
                <div
                    style={{
                        display: 'flex',
                        gap: '14px',
                        justifyContent: 'center',
                        flexWrap: 'wrap'
                    }}
                >
                    <button
                        onClick={() => {
                            window.open('mailto:sales@tier5.us', '_blank');
                            setIsVisible(false);
                        }}
                        style={{
                            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '14px 28px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            minWidth: '160px',
                            boxShadow: '0 8px 25px rgba(37, 99, 235, 0.3)',
                            textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
                        }}
                        onMouseOver={(e) => e.target.style.background = 'linear-gradient(135deg, #1d4ed8, #1e40af)'}
                        onMouseOut={(e) => e.target.style.background = 'linear-gradient(135deg, #2563eb, #1d4ed8)'}
                    >
                        Contact Sales
                    </button>

                    <button
                        onClick={() => setIsVisible(false)}
                        style={{
                            backgroundColor: '#ffffff',
                            color: '#6b7280',
                            border: '2px solid #e5e7eb',
                            borderRadius: '10px',
                            padding: '12px 26px',
                            fontSize: '15px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            minWidth: '140px'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#f9fafb';
                            e.target.style.borderColor = '#d1d5db';
                            e.target.style.color = '#374151';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#ffffff';
                            e.target.style.borderColor = '#e5e7eb';
                            e.target.style.color = '#6b7280';
                        }}
                    >
                        Remind Later
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InactiveAccountPopover; 